(function () {
  if (window.__cstmCardVariantInit) return;
  window.__cstmCardVariantInit = true;

  var variantsCache = new WeakMap();

  function getVariantsMap(wrapper) {
    if (variantsCache.has(wrapper)) return variantsCache.get(wrapper);

    var map = new Map();
    var script = wrapper.querySelector('script[data-card-variants]');
    if (script) {
      try {
        var variants = JSON.parse(script.textContent);
        variants.forEach(function (variant) {
          map.set(String(variant.id), variant);
        });
      } catch (error) {
        console.error('cstm-card-variant: failed to parse variant data', error);
      }
    }

    variantsCache.set(wrapper, map);
    return map;
  }

  function updateCardImage(wrapper, data) {
    if (!data.image) return;
    var img = wrapper.querySelector('.cstm-card__media-image');
    if (!img) return;
    img.src = data.image.src;
    img.srcset = data.image.srcset;
    img.width = data.image.width;
    img.height = data.image.height;
    if (data.image.alt) img.alt = data.image.alt;
  }

  function updateCardPrice(wrapper, data) {
    var priceWrap = wrapper.querySelector('.cstm-card__cta-price-inner');
    if (!priceWrap) return;

    var regularEl = priceWrap.querySelector('.cstm-card__cta-price-regular');
    if (regularEl) regularEl.textContent = data.moneyPrice;

    var compareEl = priceWrap.querySelector('.cstm-card__cta-price-compare');
    if (compareEl) {
      if (data.moneyCompareAtPrice) {
        compareEl.textContent = data.moneyCompareAtPrice;
        compareEl.classList.remove('hidden');
        priceWrap.classList.add('cstm-card__cta-price-inner--sale');
      } else {
        compareEl.textContent = '';
        compareEl.classList.add('hidden');
        priceWrap.classList.remove('cstm-card__cta-price-inner--sale');
      }
    }
  }

  function updateCardSavingsBadge(wrapper, data) {
    var badge = wrapper.querySelector('.cstm-card__bundle-badge');
    if (!badge) return;
    badge.textContent = data.savingsBadge || '';
    badge.classList.toggle('hidden', !data.savingsBadge);
  }

  function updateCardVariantInput(wrapper, data) {
    var input = wrapper.querySelector('.product-variant-id');
    if (input) input.value = data.id;
  }

  function updateCardAvailability(wrapper, data) {
    var button = wrapper.querySelector('.cstm-card__cta-button');
    if (!button) return;

    var label = button.querySelector('.cstm-card__cta-label');

    if (data.available) {
      button.disabled = false;
      if (label) label.textContent = button.dataset.addToCartText;
    } else {
      button.disabled = true;
      if (label) label.textContent = button.dataset.soldOutText;
    }
  }

  // Subscribe and Save / One-time Purchase radios (cards whose product has a
  // ReCharge plan -- see snippets/cstm-card-product.liquid). Keeps the
  // button price and the form's selling_plan input in step with the chosen
  // option and the selected size.
  var purchaseCache = new WeakMap();

  function getPurchaseData(wrapper) {
    if (purchaseCache.has(wrapper)) return purchaseCache.get(wrapper);
    var data = null;
    var script = wrapper.querySelector('script[data-card-purchase]');
    if (script) {
      try {
        data = JSON.parse(script.textContent);
      } catch (error) {
        console.error('cstm-card-variant: failed to parse purchase data', error);
      }
    }
    purchaseCache.set(wrapper, data);
    return data;
  }

  function applyPurchaseOption(wrapper) {
    var data = getPurchaseData(wrapper);
    var variantInput = wrapper.querySelector('.product-variant-id');
    if (!data || !variantInput) return;

    var prices = data[variantInput.value];
    if (!prices) return;

    var subRadio = wrapper.querySelector('.cstm-card__purchase-input[value="subscription"]');
    var oneTimeRadio = wrapper.querySelector('.cstm-card__purchase-input[value="onetime"]');
    var planInput = wrapper.querySelector('.cstm-card__selling-plan');

    // A size the plan doesn't cover falls back to one-time.
    var canSubscribe = !!prices.sub;
    if (subRadio) {
      subRadio.disabled = !canSubscribe;
      if (!canSubscribe && subRadio.checked && oneTimeRadio) oneTimeRadio.checked = true;
    }

    var subscribing = canSubscribe && !!subRadio && subRadio.checked;
    if (planInput) planInput.disabled = !subscribing;
    updateCardPrice(wrapper, subscribing ? prices.sub : prices.oneTime);
  }

  function onPillChange(event) {
    var input = event.target;
    if (!input.matches || !input.matches('.cstm-card__size-pill-input')) return;

    var wrapper = input.closest('.cstm-card-wrapper');
    if (!wrapper) return;

    var data = getVariantsMap(wrapper).get(input.value);
    if (!data) return;

    updateCardImage(wrapper, data);
    updateCardPrice(wrapper, data);
    updateCardSavingsBadge(wrapper, data);
    updateCardVariantInput(wrapper, data);
    updateCardAvailability(wrapper, data);
    applyPurchaseOption(wrapper);
  }

  function onPurchaseChange(event) {
    var input = event.target;
    if (!input.matches || !input.matches('.cstm-card__purchase-input')) return;

    var wrapper = input.closest('.cstm-card-wrapper');
    if (wrapper) applyPurchaseOption(wrapper);
  }

  document.addEventListener('change', onPillChange);
  document.addEventListener('change', onPurchaseChange);
})();
